export default [
  {
    title: 'Jaaropgave',
    icon: 'FileTextIcon',
    route: 'annual-statement',
  },
]
